import { render, staticRenderFns } from "./LayerZoomLevelDescription.vue?vue&type=template&id=21b54c2c&scoped=true"
import script from "./LayerZoomLevelDescription.vue?vue&type=script&lang=js"
export * from "./LayerZoomLevelDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b54c2c",
  null
  
)

export default component.exports